module.exports = __webpack_public_path__ + "media/images/logo/logo_prex_bianco-bb9988d94031863c044b16c34e7250b4.png";